import { ENDPOINT } from '~/constants';

import { type UUID } from '~/types/common';

import { HTTPError, vestigasApi } from '~/services/kyClient';
import ToastService from '~/services/toast.service';

import { i18n, log } from '~/utils';

import { type DismissInvoiceProcessResponse } from './types';

/**
 * Dismisses a reprocessing invoice process with the given process ID.
 * @param payload - The payload containing the process ID.
 * @throws Error if the API request fails.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoice/operation/dismiss_invoice_process_invoice_process__process_id__dismiss_post
 */
export const dismissInvoiceProcess = async (processId: UUID) => {
  try {
    const response = await vestigasApi
      .put(ENDPOINT.INVOICE_REPROCESSING.DISMISS(processId))
      .json<DismissInvoiceProcessResponse>();

    return response;
  } catch (error) {
    log.error({
      message: 'Error dismissing invoice process',
      error,
    });

    let errorMessage = '';

    if (error instanceof HTTPError) {
      switch (error.response.status) {
        case 400: {
          errorMessage = i18n.t(($) => $.dismissInvoiceProcess.error400, {
            ns: 'data',
          });
          break;
        }

        case 404: {
          errorMessage = i18n.t(($) => $.dismissInvoiceProcess.error404, {
            ns: 'data',
          });
          break;
        }

        default: {
          errorMessage = i18n.t(($) => $.dismissInvoiceProcess.error.generic, {
            ns: 'data',
          });
          break;
        }
      }
    }

    if (errorMessage) {
      ToastService.error(errorMessage);
    }

    // Re-throw the error to propagate it to the calling function.
    throw error;
  }
};
